export function incrementMap<TMapKey>(map: Map<TMapKey, number>, key: TMapKey, by: number = 1) {
    let current_value: number|undefined = map.get(key);
    if (!current_value) {
        map.set(key, by);
        return;
    }
    current_value += by;
    map.set(key, current_value);
}
